// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__WQaWS","description":"MealItem_description__eVEqU","price":"MealItem_price__SnkcJ"};